import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Container,
	TextField,
	Icon,
} from "@material-ui/core";
import TextEditorComponent from "../textEditor/TextEditor";
import ImageUpload from "../../containers/upload/imageUpload";
import { Typography } from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import { dangerColor } from "../../../assets/styles/base";

const useStyles = makeStyles((theme) => ({
	cardRoot: {
		padding: "3vh 3%",
		"@media (max-width: 600px)": {
			padding: "3vh 0%",
			marginLeft: "-15px",
			width: "109%",
		},
	},
	cardContent: {
		display: "flex",
		flexDirection: "column",
	},
	cardActions: {
		display: "flex",
		justifyContent: "flex-end",
		paddingRight: "15px",
	},
	title: {
		margin: "10px 0",
	},
	input: {
		margin: "10px 0",
	},
	benefitsInputs: {
		display: "flex",
		flexDirection: "row",
		gap: "10px 30px",
		alignItems: "center",
		"@media (max-width: 600px)": {
			flexDirection: "column",
			gap: "0",
			alignItems: "inherit",
			padding: "10px",
		},
	},
}));

export default ({ title, onSubmit, openToast, isLoading, baseProductData }) => {
	const classes = useStyles();
	const [state, setState] = useState(
		baseProductData._id
			? {
					title: baseProductData.title,
					summary: baseProductData.summary,
					textContent: baseProductData.content,
					imageUrl: baseProductData.imageUrl,
					pdfUrl: baseProductData.pdfUrl,
					benefits: baseProductData.benefits,
					requirements: baseProductData.requirements,
			  }
			: {
					title: "",
					summary: "",
					textContent: "",
					imageUrl: "",
					benefits: [],
					requirements: [],
			  }
	);
	const handleChange = (event) => {
		const { id, value } = event.target;

		setState({ ...state, [id]: value });
	};
	const handleChangeText = (value) => {
		setState((prevState) => ({ ...prevState, textContent: value }));
	};
	const handleImageUploaded = (imageUrl) =>
		setState((prevState) => ({ ...prevState, imageUrl }));

	const handlePdfUploaded = (pdfUrl) =>
		setState((prevState) => ({ ...prevState, pdfUrl }));

	const handleAddRequirement = () => {
		const reqs = state.requirements || [];
		reqs.push(state.requirement);
		setState((prevState) => ({
			...prevState,
			requirements: reqs,
			requirement: "",
		}));
	};

	const handleAddBenefit = () => {
		const benefits = state.benefits || [];
		benefits.push(state.benefit);
		setState((prevState) => ({
			...prevState,
			benefits: benefits,
			benefit: "",
		}));
	};

	const handleRemoveBenefit = (benefit) => {
		setState((prevState) => ({
			...prevState,
			benefits: prevState.benefits.filter((elt) => elt !== benefit),
		}));
	};

	const handleRemoveRequirement = (requirement) => {
		setState((prevState) => ({
			...prevState,
			requirements: prevState.requirements.filter((elt) => elt !== requirement),
		}));
	};

	const handleSubmit = () => {
		if (
			(!state.title,
			!state.summary,
			!state.textContent,
			!state.imageUrl,
			!state.benefits,
			!state.requirements)
		) {
			return openToast({
				message: "Kindly make sure all fields are filled",
				type: "warning",
			});
		}

		onSubmit(state);
	};

	return (
		<Container justify="center" maxWidth="md">
			<Card className={classes.cardRoot}>
				<CardHeader title={title || "Article Form"} />
				<CardContent className={classes.cardContent}>
					<TextField
						id="title"
						label="Title"
						variant="outlined"
						className={classes.title}
						value={state.title}
						onChange={handleChange}
					/>

					<TextField
						id="summary"
						label="Summary"
						multiline
						minRows={4}
						value={state.summary}
						onChange={handleChange}
						variant="outlined"
						className={classes.input}
					/>
					<br></br>
					<div>
						<Typography variant="h6">Benefits</Typography>

						{state.benefits.map((elt) => (
							<div className="make_column_title" key={elt}>
								<Typography color="grey" variant="subtitle1">
									{" "}
									&gt; {elt}
								</Typography>
								&nbsp;
								<Icon
									onClick={() => handleRemoveBenefit(elt)}
									style={{ color: dangerColor[0] }}
								>
									<CloseIcon />
								</Icon>
							</div>
						))}
					</div>
					<div className={classes.benefitsInputs}>
						<TextField
							id="benefit"
							label="Benefit"
							variant="outlined"
							className={classes.title}
							fullWidth
							value={state.benefit}
							onChange={handleChange}
							required
						/>
						<Button onClick={handleAddBenefit} variant="outlined">
							Add
						</Button>
					</div>
					<br></br>
					<div>
						<Typography variant="h6">Requirements</Typography>

						{state.requirements.map((elt) => (
							<div className="make_column_title" key={elt}>
								<Typography color="grey" variant="subtitle1">
									{" "}
									&gt; {elt}
								</Typography>
								&nbsp;
								<Icon
									onClick={() => handleRemoveRequirement(elt)}
									style={{ color: dangerColor[0] }}
								>
									<CloseIcon />
								</Icon>
							</div>
						))}
					</div>
					<div className={classes.benefitsInputs}>
						<TextField
							id="requirement"
							label="Requirement"
							variant="outlined"
							fullWidth
							className={classes.title}
							value={state.requirement}
							onChange={handleChange}
							required
						/>
						<Button onClick={handleAddRequirement} variant="outlined">
							Add
						</Button>
					</div>
					<br></br>
					<Typography variant="subtitle1">Product Photo</Typography>
					<ImageUpload
						isSmall
						onFileUploaded={handleImageUploaded}
						defaultImg={state.imageUrl}
					/>
					<br></br>
					<Typography variant="subtitle1">Product PDF File</Typography>
					<div className={classes.input}>
						<ImageUpload
							onFileUploaded={handlePdfUploaded}
							isFileUpload
							defaultImg={state.pdfUrl}
							destination="products"
						/>
					</div>
					<div className={classes.input}>
						<TextEditorComponent
							value={state.textContent}
							onTextChange={handleChangeText}
						/>
					</div>
				</CardContent>
				<CardActions className={classes.cardActions}>
					<Button
						variant="outlined"
						onClick={handleSubmit}
						sx={{
							color: "#E00186",
							border: "1px solid #E00186",
							"&:hover": {
								color: "#fff",
								backgroundColor: "#E00186",
								border: "1px solid #E00186",
							},
						}}
					>
						{isLoading ? "Saving..." : "Save Product"}
					</Button>
				</CardActions>
			</Card>
		</Container>
	);
};
